module.exports = __webpack_public_path__ + "static/img/pro02.27f12f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/pro02.jpg
// module id = rqy5
// module chunks = 1